import React, { useState } from "react";
import Icon from "../../../components/AppIcon.jsx";
import Image from "../../../components/AppImage.jsx";

const testimonialsData = [
{
  id: 1,
  name: "Marcus Chen",
  role: "CTO, TechNova Inc.",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18b84cf35-1763296048414.png",
  avatarAlt: "Professional headshot of Asian man in his 40s with short black hair wearing a dark blazer and white shirt",
  rating: 5,
  text: "Rehma is one of the most talented front-end developers I\'ve worked with. Her ability to translate complex designs into performant React applications is exceptional. She elevated our entire engineering team\'s standards."
},
{
  id: 2,
  name: "Sarah Mitchell",
  role: "Product Manager, Pixel & Code Agency",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_12f46b4fd-1763297574350.png",
  avatarAlt: "Professional headshot of Caucasian woman in her 30s with blonde hair wearing a teal blazer in an office setting",
  rating: 5,
  text: "Working with Rehma was a pleasure from start to finish. She asks the right questions, delivers pixel-perfect work, and always goes above and beyond. Our clients consistently praised the quality of her implementations."
},
{
  id: 3,
  name: "David Okafor",
  role: "Founder, StartupHub NYC",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1afdf017e-1763293732490.png",
  avatarAlt: "Professional headshot of Nigerian man in his late 30s with a warm smile wearing a navy suit in a modern office",
  rating: 5,
  text: "Rehma joined us as a junior developer and quickly became indispensable. Her growth trajectory was remarkable — within 6 months she was leading feature development and mentoring other team members."
},
{
  id: 4,
  name: "Priya Sharma",
  role: "Lead Designer, WebCraft Studios",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d1a6cf71-1763301532880.png",
  avatarAlt: "Professional headshot of South Asian woman in her late 20s with long dark hair wearing a red top against a light background",
  rating: 5,
  text: "As a designer, finding a developer who truly understands design intent is rare. Rehma not only implements designs accurately but also suggests improvements that make the final product even better."
}];


export default function TestimonialsSection() {
  const [active, setActive] = useState(0);

  return (
    
    <div   id="" className="py-16 md:py-20" style={{ background: "var(--color-card)" }}>
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-xs font-semibold tracking-widest uppercase mb-2" style={{ color: "var(--color-primary)", fontFamily: "var(--font-caption)" }}>
            What People Say
          </p>
          <h2 className="text-3xl md:text-4xl font-bold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
            Testimonials
          </h2>
        </div>

        {/* Featured Testimonial */}
        <div
          className="p-6 md:p-10 rounded-xl border mb-6 relative"
          style={{ background: "var(--color-background)", borderColor: "rgba(124,106,247,0.2)" }}>
          
          <div
            className="absolute top-6 left-6 text-6xl leading-none font-serif"
            style={{ color: "var(--color-primary)", opacity: 0.15 }}>
            
            "
          </div>
          <div className="flex flex-col items-center text-center">
            <div className="flex gap-1 mb-4">
              {Array.from({ length: testimonialsData?.[active]?.rating })?.map((_, i) =>
              <Icon key={i} name="Star" size={18} color="#F59E0B" />
              )}
            </div>
            <p className="text-base md:text-lg leading-relaxed mb-6 max-w-2xl" style={{ color: "var(--color-foreground)", fontStyle: "italic" }}>
              "{testimonialsData?.[active]?.text}"
            </p>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0" style={{ border: "2px solid rgba(124,106,247,0.3)" }}>
                <Image
                  src={testimonialsData?.[active]?.avatar}
                  alt={testimonialsData?.[active]?.avatarAlt}
                  className="w-full h-full object-cover" />
                
              </div>
              <div className="text-left">
                <div className="font-bold text-sm" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
                  {testimonialsData?.[active]?.name}
                </div>
                <div className="text-xs" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
                  {testimonialsData?.[active]?.role}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Selector */}
        <div className="flex gap-3 justify-center flex-wrap">
          {testimonialsData?.map((t, i) =>
          <button
            key={t?.id}
            onClick={() => setActive(i)}
            className="flex items-center gap-2 px-3 py-2 rounded-xl border transition-all duration-200"
            style={{
              background: active === i ? "rgba(124,106,247,0.15)" : "var(--color-background)",
              borderColor: active === i ? "var(--color-primary)" : "var(--color-border)",
              boxShadow: active === i ? "0 0 12px rgba(124,106,247,0.2)" : "none",
            }}>
            
              <div className="w-7 h-7 rounded-lg overflow-hidden flex-shrink-0">
                <Image src={t?.avatar} alt={t?.avatarAlt} className="w-full h-full object-cover" />
              </div>
              <span
              className="text-xs font-medium hidden sm:block"
              style={{ color: active === i ? "var(--color-primary)" : "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
              
                {t?.name?.split(" ")?.[0]}
              </span>
            </button>
          )}
        </div>
      </div>
    </div>);

}